function requestAnimation(callback) {
  let wait

  return function (...args) {
    if (wait) return
    wait = true

    requestAnimationFrame(() => {
      wait = false
      callback(...args)
    })
  }
}

module.exports = requestAnimation
